// Italian

export default {

  component: {
    jobAdList: {
      title: 'Posizioni di lavoro aperte',
      jobs: 'lavori',
      noJobAds: 'Al momento non ci sono posizioni aperte.',
    },

    jobAdCard: {
      openUntil: date => `attiva fino a ${date}`,
    },

    jobAdGreetings: {
      thankYou: 'Grazie.',
      readyInfo: 'La tua candidatura è stata ricevuta e il reclutatore ti contatterà a breve.',
      luck: 'Buona fortuna!',
    },

    jobAdSeeYou: {
      title: 'Grazie.',
      description: 'La tua candidatura è stata salvata e ti abbiamo inviato un link per continuarla più tardi.',
    },

    unpublished: {
      title: 'Non pubblicato',
      info: 'L’annuncio di lavoro non è stato ancora pubblicato.',
    },
  },

  page: {},

}
